<template>
  <div></div>
</template>
<script>
import * as frame from "@/dianwuyi/frame";

export default {
  components: {},
  data() {
    return {}
  },
  async created() {
    let _this = this
    setTimeout(() => {
      wx.invoke('getCurExternalContact', {}, function (res) {
        if (res.err_msg == "getCurExternalContact:ok") {
          let externalUserId = res.userId; //返回当前外部联系人userId
          _this.$router.replace({
            path: "/work/detail",
            query: {
              ExternalUserId: externalUserId,
              r_t: new Date().getTime()
            }
          });
        } else {
          alert("getCurExternalContact error:" + JSON.stringify(res))
          //错误处理
        }
      })
    }, 2000)//显示不出来客户详情页，把这个秒数再加大
  },
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
